import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'

const TeamSpreadsheet = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`Spreadsheet | ${team.name} | ${guild.name}`}>
      TeamSpreadsheet! {team.id}
    </Section>
  )
}

export default TeamSpreadsheet
